module.exports = __webpack_public_path__ + "static/media/display15.b2ee919d.jpg";